<div class="categories-banner">
  <h3>Categories</h3>
  <div class="grid">
    <div class="col-2" *ngFor="let category of categories">
      <div
        class="category"
        [ngStyle]="{ backgroundColor: category.color }"
        [routerLink]="'/category/' + category.id"
      >
        <div class="category-icon">
          <i class="pi pi-{{ category.icon }}"></i>
        </div>
        <div class="category-name">{{ category.name }}</div>
      </div>
    </div>
  </div>
</div>
